'use strict';

FocusDirective.$inject = ['$timeout'];

function FocusDirective($timeout) {
    return {
        scope: { trigger: '=focusMe' },
        link: function(scope, element) {
            scope.$watch('trigger', function(value) {
                console.log('trigger',value);
                if (value === true) {
                    $timeout(function() {
                        console.log(element);
                        element[0].focus();
                        //scope.trigger = false;
                    });
                }
            });
        }
    };
}

export default FocusDirective;
